import React from 'react';

import { Icon } from '../icons';

export const ShareIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M26.642974,13.0462552 L19.0803003,6.26121969 C18.4183236,5.66724728 17.3749991,6.14943413 17.3749991,7.07211145 L17.3749991,10.6459013 C10.4729701,10.7279994 4.99999612,12.1651849 4.99999612,18.9609793 C4.99999612,21.7038774 6.70074263,24.4211951 8.58071183,25.8418628 C9.16736432,26.2852105 10.0034505,25.7287826 9.78714572,25.0101229 C7.83877025,18.536337 10.7112749,16.8176786 17.3749991,16.7180805 L17.3749991,20.642852 C17.3749991,21.5669579 18.41914,22.0470019 19.0803003,21.4537438 L26.642974,14.6680387 C27.1186812,14.2411643 27.1193257,13.4737099 26.642974,13.0462552 Z" />
    </svg>
  );
};
